import ListTile from 'components/ListTile';
import LoadingShape from 'components/LoadingShape';
import getDisplayName from 'data/services/profile/getDisplayName';
import { Customer } from 'data/firestore/agent/customer/types';
import { EntityGet } from 'data/firestore/types';
import getInitials from 'data/services/string/getInitials';
import useCustomerPanel from 'hooks/useCustomerPanel';
import { Container, StyledUserAvatar } from './styled';

const CustomerInfo = ({
    customer,
    isLoading = false,
}: {
    customer?: EntityGet<Customer> | null;
    isLoading?: boolean;
}) => {
    const { openCustomerPanel } = useCustomerPanel();

    const displayName = getDisplayName(customer);

    const customerInitials = displayName === 'Unknown' ? null : getInitials(displayName);

    if (isLoading) return <LoadingShape />;

    return (
        <Container>
            <ListTile
                icon={(
                    <StyledUserAvatar
                        initials={customerInitials}
                        src={customer?.photoURL}
                        value={customer?.id}
                        channel={customer?.channel}
                    />
                )}
                title={displayName}
                subtitle={customer?.address?.formatted}
                onClick={() => openCustomerPanel({ data: customer })}
            />
        </Container>
    );
};

export default CustomerInfo;
